import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import {
  FetchFromServer,
  FetchPlainFromServer,
  InsertToServer,
  UpdateToServer,
  DeleteFromServer,
} from "../api/ServerApi";


function Sidebar({ selectedPanel }) {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  /* ================= Marathi Words ================= */
  const [showMarathiPanel, setShowMarathiPanel] = useState(false);
  const [marathiList, setMarathiList] = useState([]);
  const [marathiLoading, setMarathiLoading] = useState(false);

  /* ================= English Words ================= */
  const [showEnglishPanel, setShowEnglishPanel] = useState(false);
  const [englishList, setEnglishList] = useState([]);
  const [englishLoading, setEnglishLoading] = useState(false);
  const [selectedMarathiWord, setSelectedMarathiWord] = useState("");

  /* ================= Editing / Selection ================= */
  const [editingId, setEditingId] = useState(null);
  const [editedValue, setEditedValue] = useState("");
  const [selectedEnglishRowId, setSelectedEnglishRowId] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [activationCode, setActivationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const isSuperAdmin = localStorage.getItem("SuperAdmin") === "1";

  const sidebarColor = selectedPanel
    ? `rgb(${selectedPanel.Fore_RedCPer}, ${selectedPanel.Fore_GreenPer}, ${selectedPanel.Fore_BluePer})`
    : "#2c3e50";

  /* ================= MARATHI LIST ================= */
  const fetchMarathiWordsList = async () => {
    try {
      setMarathiLoading(true);
      const data = await FetchFromServer(
        "GetListOfEnglishWordsWithSameMarathiWords",
        {}
      );
      setMarathiList(Array.isArray(data) ? data : []);
      setShowMarathiPanel(true);
    } catch {
      alert("Failed to load Marathi words list");
    } finally {
      setMarathiLoading(false);
    }
  };

  /* ================= ENGLISH LIST ================= */
  const fetchEnglishWords = async (marathiWord) => {
    try {
      setEnglishLoading(true);
      setSelectedMarathiWord(marathiWord);

      const data = await FetchPlainFromServer(
        "GetEnglishWordsListByMarathiWords",
        { MarathiWords: marathiWord }
      );

      setEnglishList(Array.isArray(data) ? data : []);
      setSelectedEnglishRowId(null);
      setShowEnglishPanel(true);
    } catch {
      alert("Failed to load English words");
    } finally {
      setEnglishLoading(false);
    }
  };

  const handleOpenAddModal = () => setShowAddModal(true);

  const handleCloseAddModal = () => {
    setActivationCode("");
    setShowAddModal(false);
  };
  const handleActivationSubmit = async () => {
    if (
      activationCode.length < 3 ||
      activationCode.length > 5 ||
      isNaN(activationCode)
    ) {
      alert("Activation code must be 3, 4, or 5 digits");
      return;
    }

    setLoading(true);
    try {
      // ✅ PLAIN API + STRING PAYLOAD
      const data = await FetchPlainFromServer(
        "GetCandidateDetailsForCorporationByDataPassword",
        { DataPassword: activationCode }
      );

      if (!Array.isArray(data) || data.length === 0) {
        alert("No candidate found for this activation code");
        return;
      }

      const userId = Number(localStorage.getItem("UserId"));

      await Promise.all(
        data.map((item) =>
          InsertToServer(
            "AddUserCorpCandidatePanelMapping",
            {
              UserId: userId,
              CorpCandidateMappingId: item.CorpCandidateMappingId,
            },
            { plain: true }
          )
        )
      );

      alert("Constitution added successfully!");
      handleCloseAddModal();
    } catch (err) {
      console.error("Add Constitution Error:", err);
      alert("Failed to add constitution");
    } finally {
      setLoading(false);
    }
  };







  const handleConfirmDelete = async () => {
    setShowDeleteConfirm(false); // STEP 4: close modal
    setLoading(true);

    try {
      const userId = Number(localStorage.getItem("UserId"));

      if (!userId || !selectedPanel) {
        alert("Invalid user or panel");
        return;
      }

      const payload = {
        where: `UserId = ${userId}
              AND CorporationId = ${Number(selectedPanel.CorporationId)}
              AND PanelNumber = ${Number(selectedPanel.PanelNumber)}`,
      };

      console.log("DELETE PAYLOAD →", payload);

      // ✅ THIS IS THE FIX
      await FetchPlainFromServer(
        "deleteUserCorpCandidatePanelMapping",
        payload
      );

      // alert("Constitution deleted successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Delete API Error:", error);
      // alert("Failed to delete constitution");
    } finally {
      setLoading(false);
    }
  };





  /* ================= AUTO SAVE ================= */
  const autoSaveEnglishWord = async (row) => {
    // 🛑 prevent double execution (Enter + Blur)
    if (isSaving) return;
    if (editingId !== row.MarathiWordId) return;

    const newValue = editedValue.trim();

    if (!newValue || newValue === row.EnglishWords) {
      setEditingId(null);
      return;
    }

    const payload = {
      data: {
        EnglishWords: newValue,
      },
      where: `MarathiWordId = ${row.MarathiWordId}`,
    };

    // ✅ PRINT PAYLOAD (you asked for this)
    console.log("UPDATE PAYLOAD →", JSON.stringify(payload));

    try {
      setIsSaving(true);

      await UpdateToServer(
        "Updatemarathiwords",
        payload
      );


      // ✅ update UI (existing logic preserved)
      setEnglishList((prev) =>
        prev.map((r) =>
          r.MarathiWordId === row.MarathiWordId
            ? { ...r, EnglishWords: newValue }
            : r
        )
      );
    } catch (err) {
      console.error("Update failed:", err);
      alert("Update failed");
    } finally {
      setIsSaving(false);
      setEditingId(null);
      setEditedValue("");
    }
  };

  // STEP 1: open delete confirmation
  const handleDeleteClick = () => {
    if (!selectedPanel) {
      alert("Please select a panel first");
      return;
    }
    setShowDeleteConfirm(true);
  };


  /* ================= DELETE OTHERS ================= */
  const handleDeleteExceptSelected = async () => {
    if (!selectedEnglishRowId) return;

    const idsToDelete = englishList
      .filter((r) => r.MarathiWordId !== selectedEnglishRowId)
      .map((r) => r.MarathiWordId);

    if (idsToDelete.length === 0) return;

    try {
      await DeleteFromServer(
        "deletemarathiwords",
        {
          table: "marathiwords",
          where: `MarathiWordId IN (${idsToDelete.join(",")})`,
        },
        { plain: true }
      );

      // alert("Other rows deleted successfully");

      // ✅ Keep only selected row in UI
      setEnglishList((prev) =>
        prev.filter((r) => r.MarathiWordId === selectedEnglishRowId)
      );
    } catch (err) {
      console.error(err);
      alert("Delete failed");
    }
  };



  // eslint-disable-next-line react-hooks/exhaustive-deps
  /* ================= F10 KEY ================= */
  useEffect(() => {
    const onKeyDown = (e) => {
      if (!showEnglishPanel) return;
      if (!selectedEnglishRowId) return;

     if (e.key === "F10") {
  e.preventDefault();
  handleDeleteExceptSelected();

  // ✅ CLOSE RIGHT ENGLISH BOX
  setShowEnglishPanel(false);
  setEnglishList([]);
  setSelectedMarathiWord("");
  setSelectedEnglishRowId(null);

  // ✅ REFRESH LEFT MARATHI LIST FROM API
  fetchMarathiWordsList();
}


    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [showEnglishPanel, selectedEnglishRowId, englishList]);

  /* ================= LOGOUT ================= */
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      {/* ================= SIDEBAR ================= */}
      <div
        style={{
          width: 240,
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          background: sidebarColor,
          padding: 25,
          color: "white",
          overflowY: "auto",
          zIndex: 1,
        }}
      >
        <h4>Sidebar</h4>

        <div className="d-grid gap-3">
          <Button
            variant="primary"
            onClick={handleOpenAddModal}
          >
            Add Constitution
          </Button>


          <Button
            variant="danger"
            onClick={handleDeleteClick}
            disabled={loading || !selectedPanel}
          >
            Delete Constitution
          </Button>




          {isSuperAdmin && (
            <Link to="/marathiwords">
              <Button variant="info" style={{ width: "100%" }}>
                Marathi Words
              </Button>
            </Link>
          )}

          <Button variant="secondary" onClick={fetchMarathiWordsList}>
            Marathi Words List
          </Button>

          <Button variant="warning" onClick={() => setShowLogoutConfirm(true)}>
            Logout
          </Button>
        </div>
      </div>

{/* ================= MARATHI LOADING POPUP ================= */}
<Modal
  show={marathiLoading}
  backdrop="static"
  keyboard={false}
  centered
>
  <Modal.Body
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 30,
    }}
  >
    <div
      className="spinner-border text-primary"
      role="status"
      style={{ marginBottom: 15 }}
    >
      <span className="visually-hidden">Loading...</span>
    </div>

    <div style={{ fontSize: 14, fontWeight: 600 }}>
      Please wait, Loading Data
    </div>
  </Modal.Body>
</Modal>


      {/* ================= ADD CONSTITUTION MODAL ================= */}
      <Modal show={showAddModal} onHide={handleCloseAddModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Constitution</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Activation Code</Form.Label>
            <Form.Control
              type="text"
              value={activationCode}
              maxLength={5}
              placeholder="Enter 3–5 digit code"
              onChange={(e) => setActivationCode(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseAddModal}>
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleActivationSubmit}
            disabled={loading}
          >
            {loading ? "Adding..." : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ================= DELETE CONFIRM ================= */}
      <Modal
        show={showDeleteConfirm}
        onHide={() => setShowDeleteConfirm(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete this constitution?
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteConfirm(false)}
          >
            No
          </Button>

          <Button
            variant="danger"
            onClick={handleConfirmDelete}
            disabled={loading}
          >
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ================= MARATHI PANEL ================= */}
      {showMarathiPanel && (
        <div
          style={{
            position: "fixed",
            top: 70,
            left: 240,
            width: "35%",
            height: "calc(100vh - 90px)",
            background: "#fff",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ padding: 10, borderBottom: "1px solid #ddd" }}>
            <b>Marathi Words</b>
            <button style={{ float: "right" }} onClick={() => {
              setShowMarathiPanel(false);   // close Marathi panel
              setShowEnglishPanel(false);   // close English panel
              setEnglishList([]);           // clear English list
              setSelectedMarathiWord("");   // clear selected Marathi word
              setSelectedEnglishRowId(null); // clear selection
            }}
            >
              ❌
            </button>
          </div>

          <div style={{ flex: 1, overflowY: "auto", padding: 10 }}>
            <table className="table table-hover">
              <tbody>
                {marathiList.map((row, i) => (
                  <tr key={i} onClick={() => fetchEnglishWords(row.MarathiWords)}>
                    <td>{row.MarathiWords}</td>
                    <td>{row.DuplicateCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ================= ENGLISH PANEL ================= */}
      {showEnglishPanel && (
        <div
          style={{
            position: "fixed",
            top: 70,
            left: "calc(240px + 36%)",
            width: "40%",
            height: "calc(100vh - 90px)",
            background: "#fff",
            zIndex: 1001,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ padding: 10, borderBottom: "1px solid #ddd" }}>
            <b>English Words for {selectedMarathiWord}</b>
            <span style={{ marginLeft: 10, fontSize: 12, color: "#888" }}>
              (F10 = Delete others)
            </span>
            <button style={{ float: "right" }} onClick={() => setShowEnglishPanel(false)}>
              ❌
            </button>
          </div>

          <div style={{ flex: 1, overflowY: "auto", padding: 10 }}>
            <table className="table table-hover">
              <tbody>
                {englishList.map((row) => (
                  <tr
                    key={row.MarathiWordId}
                    onClick={() => setSelectedEnglishRowId(row.MarathiWordId)}
                    onDoubleClick={() => {
                      setEditingId(row.MarathiWordId);
                      setEditedValue(row.EnglishWords);
                    }}
                    style={{
                      background:
                        selectedEnglishRowId === row.MarathiWordId
                          ? "#e6f2ff"
                          : "",
                    }}
                  >
                    <td>{row.MarathiWordId}</td>
                    <td>{row.MarathiWords}</td>
                    <td>
                      {editingId === row.MarathiWordId ? (
                        <input
                          value={editedValue}
                          autoFocus
                          onChange={(e) => setEditedValue(e.target.value)}
                          onBlur={() => autoSaveEnglishWord(row)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              autoSaveEnglishWord(row);
                            }
                            if (e.key === "Escape") {
                              setEditingId(null);
                              setEditedValue("");
                            }
                          }}
                        />

                      ) : (
                        row.EnglishWords
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ================= LOGOUT ================= */}
      <Modal show={showLogoutConfirm} onHide={() => setShowLogoutConfirm(false)} centered>
        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowLogoutConfirm(false)}>No</Button>
          <Button variant="warning" onClick={handleLogout}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Sidebar;
